import { ReplaySubject } from 'rxjs';

// as suggested by https://rxjs.dev/deprecations/multicasting
// to replace .pipe(publishReplay(1), refCount())
export function shareConfigPublishReplay<T>(replayCount = 1) {
    return {
        connector: () => new ReplaySubject<T>(replayCount),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: false
    };
}

// same thing but resetOnRefCountZero: true so we don't have to manually unsubscribe
export function shareConfigPublishReplayRefCount<T>(replayCount = 1) {
    return {
        connector: () => new ReplaySubject<T>(replayCount),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: true
    };
}
